<template>
  <div>
  <section>
    <div class="left">
      <h2 v-translate>Nastavení</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <select-box id="subject_type"
                    v-model="subscriber.subject_type"
                    :options="subjectTypeOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Typ subjektu</translate>
        </select-box>
        <select-box id="id_type"
                    v-model="subscriber.id_type"
                    :options="subscriberTypeOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Typ odběratele</translate>
        </select-box>
        <text-input id="maximum_paired_device_count"
                    v-model="subscriber.maximum_paired_device_count"
                    ref="maximumpaireddevicecountref"
                    :help-text="maxPairedDeviceCountHelpText"
                    :disabled="!isEditable"
        >
          <translate class="translate">Maximální počet spárovatelných zařízení</translate>
        </text-input>
      </div>
      <div class="field_right">
        <input id="login" name="login" type="text" style="display: none">
        <input id="password" name="password" type="password" style="display: none">
        <text-input
            id="real-login"
            v-model="login"
            ref="realloginref"
            :disabled="!isEditable"
        >
          <translate class="translate">Login</translate>
        </text-input>
        <text-input
            input-type="password"
            id="real-password"
            v-model="password"
            ref="realpasswordref"
            @focus="onPasswordFocus"
            @blur="onPasswordBlur"
            :disabled="!isEditable"
        >
          <translate class="translate">Heslo</translate>
        </text-input>
        <text-input
            input-type="password"
            id="parental_lock_pin"
            v-model="pin"
            ref="parentallockpinref"
            @focus="onPinFocus"
            @blur="onPinBlur"
            :help-text="this.$gettext('minimálně 6 číslic')"
            :disabled="!isEditable"
        >
          <translate class="translate">PIN administrátora</translate>
        </text-input>
        <checkbox-input
            id="tester"
            v-model="subscriber.force_pin_change"
            ref="forcepinchangeref"
            :disabled="!isEditable"
        >
          <translate class="translate">Vynutit změnu PIN</translate>
        </checkbox-input>
      </div>
      <div class="field_left">
        <date-picker
            id="active_from"
            date-format="d. m. yy"
            attrKey="active_from"
            v-model="subscriber.active_from"
            @update-date="updateSubscriberDate"
            :disabled="!isEditable"
        >
          <translate class="translate">Aktivní od</translate>
        </date-picker>
      </div>
      <div class="field_right">
        <date-picker
            id="active_to"
            attrKey="active_to"
            date-format="d. m. yy"
            v-model="subscriber.active_to"
            @update-date="updateSubscriberDate"
            :disabled="!isEditable"
        >
          <translate class="translate">Aktivní do</translate>
        </date-picker>
      </div>
      <div class="field field_search">
        <multiselect-searchbox
            :searchFunction="searchTag"
            v-model="subscriber.tag_ids"
            :disabled="!isEditable"
        ><translate>Štítky</translate></multiselect-searchbox>
      </div>
      <div class="field_left">
        <select-box id="timeshiftenabled"
                    v-model="shape"
                    :options="shapeOptions"
                    ref="shaperef"
                    :disabled="!isEditable"
        >
          <translate class="translate">Shapovat všechna zařízení</translate>
        </select-box>
      </div>

      <div class="field_right">
        <select-box id="type"
                    v-model="subscriber.subscription_type"
                    :options="subscriptionTypeOptions"
                    ref="subscriptiontyperef"
                    :disabled="!isEditable"
        >
          <translate class="translate">Typ předplatného</translate>
        </select-box>
      </div>
      <div class="field_right" v-if="isPromo">
        <date-picker
            id="promo_to"
            attrKey="promo_to"
            date-format="d. m. yy"
            v-model="subscriber.promo_to"
            @update-date="updateSubscriberDate"
            :disabled="!isEditable"
        >
          <translate class="translate">Promo do</translate>
        </date-picker>
        <a class="btn" @click.stop="setLastDayOfMonth(0)">Do konce měsíce</a>
        <a class="btn" @click.stop="setLastDayOfMonth(1)">+1</a>
        <a class="btn" @click.stop="setLastDayOfMonth(2)">+2</a>
        <a class="btn" @click.stop="setLastDayOfMonth(3)">+3</a>
      </div>

      <div class="field_right" v-if="$_updateActionAllowedAll">
        <checkbox-input
            id="nocache"
            v-model="subscriber.no_cache"
            ref="nocacheref"
            :disabled="isProduction || $_loggedUser_action_allowed('turnOffDeviceCache', 'update')"
        >
          <translate class="translate">Vypnout cache zařízení</translate>
        </checkbox-input>
      </div>
    </div>
  </section>
  <section>
    <div class="left">
      <h2 v-translate>Oprávnění</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <checkbox-input
            id="permissions_subscriber_profiles_restricted_create"
            v-model="subscriber.permissions_subscriber_profiles_restricted_create"
            ref="permissions_subscriber_profiles_restricted_createref"
            :disabled="!isEditable"
        >
          <translate class="translate">Vyžadovat PIN při vytváření uživatelského profilu</translate>
        </checkbox-input>
      </div>
      <div class="field_left">
        <checkbox-input
            id="permissions_subscriber_profiles_restricted_update"
            v-model="subscriber.permissions_subscriber_profiles_restricted_update"
            ref="permissions_subscriber_profiles_restricted_updateref"
            :disabled="!isEditable"
        >
          <translate class="translate">Vyžadovat PIN při editaci uživatelského profilu</translate>
        </checkbox-input>
      </div>
      <div class="field_left">
        <checkbox-input
            id="permissions_subscriber_profiles_restricted_delete"
            v-model="subscriber.permissions_subscriber_profiles_restricted_delete"
            ref="permissions_subscriber_profiles_restricted_deleteref"
            :disabled="!isEditable"
        >
          <translate class="translate">Vyžadovat PIN mazání uživatelského profilu</translate>
        </checkbox-input>
      </div>
    </div>
  </section>
    <section>
      <div class="left">
        <h2 v-translate>Obnovení hesla</h2>
      </div>

      <div class="right">
        <div class="field_left">
          <radio-input
              id="sendEmail"
              name="sendType"
              p-class="field"
              v-model="messageType"
              :val="messageType"
              :disabled="!isEditable"
          >
            <translate class="translate">Odeslat e-mailem</translate>
          </radio-input>
        </div>

        <div class="field_right">
          <p class="field">
            <input type="button"
                   class="btn"
                   :value="'Vygenerovat nové heslo' | translate"
                   :class="{btn_inactive: !passwordEditable}"
                   :disabled="!passwordEditable"
                   @click.prevent.stop="submit"
            >
          </p>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import {getCorrectBooleanValue} from "@/utils/helpers"

export default {
  name: "Settings",
  props: {
    title: String,
    subscriber: Object,
    subjectTypeOptions: Array,
    subscriberTypeOptions: Array,
    operatorsMaximumPairedDeviceCount: Number,
    maxOperatorsDeviceCount: Number,
    isEditable: Boolean,
    passwordEditable: Boolean
  },
  data() {
    return {
      passwordChanged: false,
      passwordProxy: null,
      pinFocused: false,
      messageType: "sendEmail",
    }
  },
  created(TagService) {
    this.tagService = TagService
  },
  computed: {
    isProduction() {
      return this.$_env_isProduction === 'prod'
    },
    isPromo() {
      return this.subscriber.subscription_type === 'promo'
    },
    maxPairedDeviceCountHelpText() {
      let count = null;
      if(this.subscriber.operators_maximum_paired_device_count){
        count = this.subscriber.operators_maximum_paired_device_count;
      }else if(this.maxOperatorsDeviceCount){
        count = this.maxOperatorsDeviceCount;
      }

      if(count) {
        return this.$gettext('včetně párovacích klíčů; Operátorem omezeno na max.') + ' ' + count;
      }else return '';
    },
    shapeOptions() {
      return [
        {id: null, text: this.$gettext('Neurčeno')},
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ]
    },
    login: {
      get() {
        return this.subscriber.login
      },
      set(value) {
        if (value === '') {
          this.subscriber.login = null
        } else {
          this.subscriber.login = value
        }
      }
    },
    password: {
      get() {
        if (this.subscriber.password && this.passwordChanged === false) {
          return '********'
        } else {
          if (this.subscriber.password === false) {
            return ''
          } else {
            return this.subscriber.password
          }
        }
      },
      set(value) {
        this.passwordChanged = true
        if (value === '') {
          this.subscriber.password = false
          this.$emit('set-password', false)
        } else {
          this.subscriber.password = value
          this.$emit('set-password', value)
        }
      }
    },
    pin: {
      get() {
        return this.pinFocused ? this.subscriber.parental_lock_pin : this.subscriber.parental_lock_pin || '******'
      },
      set(value) {
        this.subscriber.parental_lock_pin = value
      }
    },
    shape: {
      get() {
        return this.subscriber.shape
      },
      set(newValue) {
        this.subscriber.shape = getCorrectBooleanValue(newValue)
      }
    },
    subscriptionTypeOptions() {
      return [
        { id: 'common', text: this.$gettext('Běžné') },
        { id: 'tester', text: this.$gettext('Testovací') },
        { id: 'promo', text: this.$gettext('Promo') },
      ]
    }
  },
  methods: {
    updateSubscriberDate(dateInfo) {
      this.subscriber[dateInfo.attrKey] = dateInfo.date
    },
    onPasswordFocus() {
      if (!this.passwordChanged) {
        this.passwordProxy = this.subscriber.password
        this.subscriber.password = false
      }
    },
    onPasswordBlur() {
      if (!this.passwordChanged) {
        this.subscriber.password = this.passwordProxy
        this.passwordProxy = null
      }
    },
    onPinFocus() {
      this.pinFocused = true
    },
    onPinBlur() {
      this.pinFocused = false
    },
    resetPassword() {
      this.passwordChanged = false
      this.passwordProxy = null
    },
    setLoginInvalid(value = false, text = null) {
      this.$refs['realloginref'].setForcedInvalid(value, text)
    },
    setPasswordInvalid(value = false, text = null) {
      this.$refs['realpasswordref'].setForcedInvalid(value, text)
    },
    searchTag(search, selectAll=false) {
      return this.tagService.searchTagByNameAndOperatorId(this.subscriber.id_operator, {name_search: search, select_all: selectAll})
    },
    submit(){
      this.$emit("resetPassword", {messageType: this.messageType});
      return false;
    },
    lastDayOfMonth(months = 0) {
      const d = new Date()
      const m = d.getMonth() + months + 1
      // https://stackoverflow.com/questions/222309/calculate-last-day-of-month
      return new Date(d.getFullYear() + (m >= 12 ? 1 : 0), m % 12, 0)
    },
    setLastDayOfMonth(months = 0) {
      const d = this.lastDayOfMonth(months)
      this.updateSubscriberDate({
        attrKey: 'promo_to',
        date: d.getDate() + '. ' + (d.getMonth() + 1) + '. ' + d.getFullYear(),
      })
    },
  },
  watch: {
    'subscriber.subscription_type'(newValue) {
      if (newValue === 'promo' && this.subscriber.default_promo_length !== null) {
        this.setLastDayOfMonth(this.subscriber.default_promo_length)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/settings/Settings.vue